import Swal from 'sweetalert2';
import { questionSubscriptionTarget } from '../../questionBank/paidQuestionFlow';
import { buildQuestionBankFlowState } from '../../questionBank/qbankFlowState';

export function infographicRouteFlow(route) {
  const input = { ...route, category_id: 13 };
  const stateId = route?.stateId ?? route?.states_id ?? route?.state_id;
  const subjectId = route?.subjectId ?? route?.subject_id;
  const infographicId = route?.infographicId ?? route?.infographic_id ?? route?.infographics_id;
  if (stateId != null) { input.state_id = Number(stateId); input.selectedState = { ...input.selectedState, state_id: Number(stateId) }; }
  if (subjectId != null) { input.subject_id = Number(subjectId); input.selectedSubject = { ...input.selectedSubject, id: Number(subjectId) }; }
  if (infographicId != null) { input.infographic_id = Number(infographicId); input.selectedInfographic = { ...input.selectedInfographic, id: Number(infographicId) }; }
  if (route?.topicId != null) input.topic_id = Number(route.topicId);
  return buildQuestionBankFlowState(input);
}

export function infographicNeedsPurchase(item = {}) {
  const raw = item.raw || item;
  return String(item.freePaid ?? raw.free_paid ?? 'F').toUpperCase() === 'P' &&
    Number(item.paymentStatus ?? raw.payment_status ?? 0) !== 1;
}

export function infographicSubscriptionTarget(item = {}, context = {}, metadata = {}) {
  return questionSubscriptionTarget({ ...item, raw: { ...(item.raw || item), categoryId: 13, category_id: 13 } }, {
    ...context,
    stateId: context.stateId || context.states_id || context.state_id || context.selectedState?.state_id,
    subjectId: context.subjectId || context.subject_id || context.selectedSubject?.id,
    examId: context.examId || context.exam_id || context.exams_id || 0,
    categoryId: 13,
  }, metadata);
}

export async function promptInfographicSubscription(item, context, navigate, metadata = {}) {
  const result = await Swal.fire({ icon: 'info', title: 'Locked Infographic',
    text: item.subscriptionMessage || item.raw?.subscription_message || item.subscription_message || 'Subscribe to unlock this infographic.',
    confirmButtonText: 'Subscribe', showCancelButton: true, cancelButtonText: 'Cancel' });
  if (result.isConfirmed) {
    const target = infographicSubscriptionTarget(item, context, metadata);
    navigate(target.pathname, { state: { ...target.state,
      ...(context.subscriptionBackTarget ? { subscriptionBackTarget: context.subscriptionBackTarget } : {}),
    } });
  }
}

export function infographicDetailFlow(item, context = {}, metadata = {}) {
  const target = infographicSubscriptionTarget(item, context, metadata).state;
  const subjectId = Number(item.raw?.subject_id || item.subjectId || context.subjectId || context.subject_id || context.selectedSubject?.id || 0);
  return { ...context, ...target, state_id: target.stateId, states_id: target.stateId,
    selectedState: { ...context.selectedState, state_id: target.stateId },
    selectedSubject: { ...context.selectedSubject, id: subjectId, subject_id: subjectId },
    subject_id: subjectId, category_id: 13, categoryId: 13,
    selectedInfographic: item,
    infographicId: Number(item.id ?? item.infographic_id ?? item.infographics_id),
    infographic_id: Number(item.id ?? item.infographic_id ?? item.infographics_id),
    infographics_id: Number(item.id ?? item.infographic_id ?? item.infographics_id),
    ...(target.examId ? { exam_id: target.examId } : {}) };
}
